import { createAction, props } from '@ngrx/store';

import { InvestmentCompanyDetailed } from '../investment-companies.interface';
import { KYC, BasicUser, ObjectId } from 'src/app/core/interfaces/shared.interface';
import { Investment } from '../../investments/investments.interface';
import { ElementRef } from '@angular/core';
import { ModalDirective } from 'src/app/shared/directives/modal.directive';
import { BeneficialOwnerPEP } from '../../pep-list/pep-list.interface';

export const setInvestmentCompany = createAction(
  '[Investment Company Component] Set Investment Company',
  props<{ investmentCompany: InvestmentCompanyDetailed }>()
);

export const setInvestmentCompanyInvestments = createAction(
  '[Investment Company Component] Set Investment Company Investments',
  props<{ investments: Investment[] }>()
);

export const setInvestmentCompanyKYC = createAction('[Investment Company Component] Set Investment Company KYC', props<{ kyc: KYC[] }>());

export const setInvestmentCompanyUsers = createAction(
  '[Investment Company Component] Set Investment Company Users',
  props<{ users: BasicUser[] }>()
);

export const setInvestmentCompanyPepChecks = createAction(
  '[Investment Company Component] Set Investment Company Pep Checks',
  props<{ pepChecks: BeneficialOwnerPEP[] }>()
);

export const addAgreementLink = createAction('[Investment Company Component] Add Agreement Link', props<{ link: string }>());

export const deleteFile = createAction('[Investment Company Component] Delete File', props<{ id: string }>());

export const resetInvestmentCompanyState = createAction('[Investment Company Component] Reset Investment Company State');

// Requests

export const loadInvestmentCompany = createAction('[Request/Api Company] Load Investment Company', props<{ id: string }>());

export const loadInvestmentCompanyKYC = createAction('[Request/Api Company] Load Investment Company KYC', props<{ id: string }>());

export const loadInvestmentCompanyUsers = createAction('[Request/Api Company] Load Investment Company Users', props<{ id: string }>());

export const openPepCheckModal = createAction(
  '[Request/Api Company] Open create manual pep check modal',
  props<{ companyId: string; companyName: string; modal: ModalDirective }>()
);

export const loadInvestmentCompanyPepChecks = createAction(
  '[Request/Api Company] Load Investment Company Pep Checks',
  props<{ id: string }>()
);

export const createManualPepCheck = createAction(
  '[Request/Api Company] Create Investment Company Pep Checks',
  props<{ investmentCompanyId: string; updateSet: { pepCheck: ObjectId; status: string; comment: string }[] }>()
);
